import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var CustomYAxisTick = function (props) {
    var x = props.x, y = props.y, textAnchor = props.textAnchor, orientation = props.orientation, labelElements = props.labelElements;
    return (_jsx("text", { x: x, y: y, textAnchor: textAnchor, fill: "white", orientation: orientation, children: labelElements }));
};
